export const Ded = {
  id: 30,
  height: 5889939,
  data: {
    icon: "/imgs/icons/asset/ded.svg",
    about: "$DED is a DOT Meme Coin: If you have DOT you get $DED Airdrop!",
    links: [
      {
        name: "Website",
        url: "https://www.dotisded.io/",
      },
      {
        name: "Twitter: @dotisded",
        url: "https://twitter.com/dotisded",
        icon: "/imgs/icons/link-x.svg",
      },
      {
        name: "Telegram: dedbird",
        url: "https://t.me/dedbird",
        icon: "/imgs/icons/link-telegram.svg",
      },
    ],
  },
};
